import React from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../../../utils/anchorScroll'
import config from '../../../utils/config'

const WalletButton = ({ userStore, translationStore, dropdownStore, guidedIntroductionStore }) => {
  const walletContent = (userStore.currentUser && userStore.currentUser.balance ? userStore.currentUser.balance.toFixed(2) : '-')

  const onWalletClick = () => {
    dropdownStore.closeDropdown()
    anchorScroll('top', '/wallet')
  }

  const onIntroductionClass = () =>  guidedIntroductionStore.showIntroduction && 'z-m1'

  return (
    <span className={`nav-perfil__cashback ${onIntroductionClass()} `} onClick={onWalletClick} name='step-5'>
      <div className='nav-perfil__cashback__inner'>
        <img src='/img/cart.svg' alt='Shopping Cart'/>
        <div className='nav-perfil__cashback__text'>
          <p className='cashback'>{walletContent+ '€'}</p>
          <p className='cashback-detail'>{translationStore.translate('header_my_easyplus').toUpperCase()}</p>
        </div>
      </div>
    </span>
  )
}

export default inject('translationStore', 'userStore', 'dropdownStore', 'guidedIntroductionStore')(observer(WalletButton))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedInHeader/WalletButton.js